// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-border[data-v-1eee7675]{position:relative}.section-border[data-v-1eee7675]:before{content:\"\";position:absolute;height:var(--height);width:1px;border-right:var(--lineWidth) var(--lineStyle) var(--lineColor);top:3px;left:var(--lineLeft)}.diagonalLine[data-v-1eee7675]{width:24px;height:8px;background:#f2f3f5;transform:rotate(-45deg)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
